var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          attrs: {
            shadow: "never",
            "body-style": { padding: "20px 20px 2px" },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "规格名称" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入规格名称" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.search($event)
                      },
                    },
                    model: {
                      value: _vm.query.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.search } },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "mt14",
          attrs: { shadow: "never", "body-style": { padding: "20px" } },
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["distribution:store:product:rule:save"],
                  expression: "['distribution:store:product:rule:save']",
                },
              ],
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.openEditor()
                },
              },
            },
            [_vm._v(" 新增规格 ")]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "mt20",
              attrs: { data: _vm.rows, size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              false
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "80" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  prop: "ruleName",
                  label: "规格名称",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "规格内容", "min-width": "360" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        _vm.parseRule(scope.row.ruleValue),
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "rule-line" },
                            [
                              _c("strong", [_vm._v(_vm._s(item.value) + "：")]),
                              _vm._v(
                                _vm._s(_vm.formatDetails(item.detail)) + " "
                              ),
                            ]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "updateTime", label: "更新时间", width: "170" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "130", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["distribution:store:product:rule:save"],
                                expression:
                                  "['distribution:store:product:rule:save']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.openEditor(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: [
                                  "distribution:store:product:rule:delete",
                                ],
                                expression:
                                  "['distribution:store:product:rule:delete']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.remove(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.query.limit,
                  "current-page": _vm.query.page,
                  total: _vm.total,
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.sizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.id ? "编辑规格" : "新增规格",
            visible: _vm.visible,
            width: "680px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            closed: _vm.clearForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "90px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "规格名称", prop: "ruleName" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "60", "show-word-limit": "" },
                    model: {
                      value: _vm.form.ruleName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "ruleName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.ruleName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "规格项", required: "" } },
                [
                  _vm._l(_vm.form.items, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "spec-row" },
                      [
                        _c("el-input", {
                          staticClass: "spec-name",
                          attrs: {
                            placeholder: "规格名，如颜色",
                            maxlength: "30",
                          },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(
                                item,
                                "value",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "item.value",
                          },
                        }),
                        _c("el-input", {
                          attrs: {
                            placeholder: "规格值用英文逗号分隔，如红色,蓝色",
                            maxlength: "300",
                          },
                          model: {
                            value: item.details,
                            callback: function ($$v) {
                              _vm.$set(
                                item,
                                "details",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "item.details",
                          },
                        }),
                        _c("el-button", {
                          attrs: { icon: "el-icon-delete", circle: "" },
                          on: {
                            click: function ($event) {
                              return _vm.removeItem(index)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-plus" },
                      on: { click: _vm.addItem },
                    },
                    [_vm._v("添加规格项")]
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.submit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }